import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export default function AuthenticationRouter({ children }) {
  const { isAuthenticated, loading, needsOnboarding } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (loading) return;

    const publicRoutes = [
      '/authentication-hub',
      '/email-confirmation',
      '/landing-page',
      '/public-patient-booking-screen'
    ];

    const isPublicRoute = publicRoutes?.some(route => 
      location?.pathname?.startsWith(route)
    );
    
    const isOnboardingRoute = location?.pathname === '/onboarding-flow';

    if (!isAuthenticated && !isPublicRoute) {
      navigate('/authentication-hub');
    } else if (isAuthenticated && needsOnboarding && !isOnboardingRoute) {
      // Redirect to onboarding if user hasn't completed it
      navigate('/onboarding-flow');
    } else if (isAuthenticated && isPublicRoute && !needsOnboarding) {
      navigate('/schedule-dashboard');
    }
  }, [isAuthenticated, loading, needsOnboarding, navigate, location?.pathname]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  return <>{children}</>;
}